import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SkeletonTable } from 'ui/components/skeleton';
import { currencyFormat, formatDate } from 'utilities/common';
import { Order } from 'services/action';

export const Orders = ({ data, isLoading }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.GetByInvoice']
  );

  const [orders, setOrders] = React.useState(null);

  const $onLoad = async() => {
    const req = await Dispatch(Order.$getByInvoice(data?.id));

    if (req?.message === 'success') {
      setOrders(req?.data);
    }
  }

  React.useEffect(() => {
    if (!data) return null

    $onLoad()
  }, [data]);

  if (StateLoading) {
    return <SkeletonTable headerCount={5} bodyCount={5} />;
  }

  return (
    <div>
      <div className="table-responsive m-0">
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ whiteSpace: 'initial', width: '200px' }}>Kode</td>
              <td style={{ whiteSpace: 'initial', width: '200px' }}>
                Tipe Layanan
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '200px',
                }}
              >
                Pengirim
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '200px',
                }}
              >
                Alamat Pickup
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '200px',
                  textAlign: 'end',
                }}
              >
                Total Harga
              </td>
            </tr>
          </thead>
          <tbody>
            {orders?.map((s, i) => (
              <tr key={i}>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                      {s?.code}
                    </div>
                    <small className="info text-uppercase">
                      {formatDate(s?.created_at, 'DD/MM/YYYY')}
                    </small>
                  </div>
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div>{s?.service_type?.name}</div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '200px',
                  }}
                >
                  <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                      {s?.shipper?.name}
                    </div>
                    <small className="info text-uppercase">
                      {s?.shipper?.address}
                    </small>
                  </div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '200px',
                  }}
                >
                  <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                      {s?.pickup_address?.name}
                    </div>
                    <small className="info text-uppercase">
                      {s?.pickup_address?.region?.district_name},{' '}
                      {s?.pickup_address?.region?.regency_name}
                    </small>
                  </div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '200px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.total_charges)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
